import { routes } from '../config/api_routes'

export const contactService = {

    getProducts: () => {
        return window.axios.post(routes.getProductListApi);
    },

    getSubProducts: (formData) => {
        return window.axios.post(routes.getSubProductListApi,formData);
    },

    storeContact: (formData) => {    
        return window.axios.post(routes.storeContactApi,formData);
    },
    getContact: (formData) => {
        return window.axios.post(routes.getContactApi,formData);
    },

    deleteContact: (formData) => {
        return window.axios.post(routes.deleteContact,formData);
    },

    getContactById: (formData) => {
        return window.axios.post(routes.getContactById,formData);
    },

    updateContact: (formData) => {
        return window.axios.post(routes.updateContact,formData);
    },

    sendNotifications: (formData) => {
        return window.axios.post(routes.sendNotificationsForDeals,formData);
    }

}